import { Tabs } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { PropsWithChildren } from 'react';

import BackdropBlur from '@/app/components/BackdropBlur';
import Image from '@/app/components/Image';

const TabWrapper = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <div className="relative flex size-full max-w-[361px] justify-center rounded-md">
      <BackdropBlur
        color={{ sm: 'extra-dark', lg: 'extra-dark' }}
        opacity={{ sm: 0.7, lg: 0.7 }}
        variant="card"
      />
      {children}
    </div>
  );
};

const MobileTabs = (): JSX.Element => {
  const t = useTranslations();
  return (
    <div data-cy="why-oura-mobile-tabs">
      <Tabs
        style="pill"
        tabs={[
          {
            label: t('june'),
          },
          {
            label: t('july'),
          },
          {
            label: t('august'),
          },
        ]}
        tabPanels={[
          {
            content: (
              <TabWrapper>
                <Image
                  alt={t('june_app_image_alt')}
                  className="relative rounded-md"
                  src={t('june_app_ui')}
                  width={361}
                  height={745}
                  format="png"
                />
              </TabWrapper>
            ),
          },
          {
            content: (
              <TabWrapper>
                <Image
                  alt={t('july_app_image_alt')}
                  className="relative rounded-md"
                  src={t('july_app_ui')}
                  width={361}
                  height={629}
                  format="png"
                />
              </TabWrapper>
            ),
          },
          {
            content: (
              <TabWrapper>
                <Image
                  alt={t('august_app_image_alt')}
                  className="relative rounded-md"
                  src={t('august_app_ui')}
                  width={361}
                  height={652}
                  format="png"
                />
              </TabWrapper>
            ),
          },
        ]}
      />
    </div>
  );
};

export default MobileTabs;
